import { useState } from 'react';
import { Outlet } from 'react-router-dom';
import Inactivity from '@/components/Inactivity';
import Aside from '@/components/Aside';
import navigation from '@/config/navigation';
import SSEHandler from '@/components/SSEHandler';
import { useEventSource, useEventSourceListener } from '@react-nano/use-event-source';
import vars from '@/config/vars';
import './styles';
import classes from './style.module.css';

const DefaultLayout = () => {
  const [event, setEvent] = useState();

  const url = vars.request.sseUrl;
  const [eventSource] = useEventSource(url, true);

  useEventSourceListener(
    eventSource,
    ['error', 'message'],
    async (e) => setEvent(e),
    [],
  );

  return (
    <div className={classes.layout}>
      <Aside links={navigation} />
      <main>
        <Outlet />
        <Inactivity />
        <SSEHandler event={event} />
      </main>
    </div>
  );
};

export default DefaultLayout;
